import React from 'react'
import Team from './Team'
import HeroSec from './HeroSec'
function Aboutpage() {
  return (
    <div>
          <HeroSec/>
          <Team/>
    </div>

  )
}

export default Aboutpage
